import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import router from "./router"; // Import du routeur
import { useAuthStore } from "./stores/authStore";
import { createI18n } from "vue-i18n";
import fr from "./lang/fr.json";
import "./assets/css/font-awesome.css"; // Import du fichier CSS global
import "./assets/css/themify-icons.css";
import "./assets/css/style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Offcanvas, Dropdown, Collapse } from "bootstrap";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import sanitizeService from "./services/sanitizeService";
import onlyDigits from "./directives/onlyDigits";

const i18n = createI18n({
  locale: "fr",
  fallbackLocale: "fr",
  messages: {
    fr,
  },
});

const app = createApp(App);

app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
});

app.directive("only-digits", onlyDigits);

app.use(i18n); // Configuration i18n
app.use(router); // Utilisation du routeur

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.config.globalProperties.$sanitize = sanitizeService;
app.config.globalProperties.$bootstrap = {
  Modal,
  Offcanvas,
  Dropdown,
  Collapse,
};

const authStore = useAuthStore();
authStore.initAuth();

app.mount("#app");
